const faqElements = document.querySelectorAll('.flc-container');

const openElement = (element) => {
	const elementDescription = element.querySelector(".flc-description");
	element.classList.add("active");
	elementDescription.style.maxHeight = elementDescription.scrollHeight + "px";
};

const closeElement = (element) => {
	const elementDescription = element.querySelector(".flc-description");
	element.classList.remove("active");
	elementDescription.style.maxHeight = null;
};

faqElements.forEach((element) => {
  const elementHeader = element.querySelector('.flc-header');
  const elementDescription = element.querySelector('.flc-description');
  
  elementHeader.addEventListener('click', () => {
    if (element.classList.contains('active')) {
      closeElement(element);
    } else {
      faqElements.forEach((element) => closeElement(element));
      openElement(element);
    }
  })
});